import React from 'react';
import PropTypes from 'prop-types';

import {ButtonBase, Stack, Typography} from 'views/components';
import {Translate} from 'views/module';

import {getParticipantName, getParticipantType} from '../communicationUtils';

const ParticipantSelector = (props) => {
  const {
    participantDetails,
    participantRns,
    selectedParticipantRn,
    setSelectedParticipantRn,
  } = props;

  return (
    <Stack sx={{gap: 0.85}}>
      <Typography
        sx={{
          fontSize: '10px',
          fontWeight: 700,
          lineHeight: '14px',
          color: '#9A9BAE',
          textTransform: 'uppercase',
        }}
      >
        <Translate expression='case.Communication.Participants' />
      </Typography>
      {
        participantRns.length === 0 && (
          <Typography
            sx={{
              fontSize: '13px',
              fontWeight: 400,
              color: '#6D7280',
            }}
          >
            <Translate expression='case.Communication.NoParticipants' />
          </Typography>
        )
      }
      <Stack
        sx={{
          'gap': 1,
        }}
      >
        {
          participantRns.map((participantRn) => {
            const isSelected = participantRn === selectedParticipantRn;

            return (
              <ButtonBase
                key={participantRn}
                onClick={() => setSelectedParticipantRn(participantRn)}
                sx={{
                  'display': 'block',
                  'width': '100%',
                  'minHeight': '53px',
                  'textAlign': 'left',
                  'border': '1px solid',
                  'borderColor': isSelected ? '#EB7A58' : '#ECECF1',
                  'borderRadius': '9px',
                  'p': '9px 13px',
                  'backgroundColor': isSelected ? '#FFF4EE' : '#FFFFFF',
                  '&:hover': {
                    backgroundColor: isSelected ? '#FFF1EA' : '#F7F8FA',
                    borderColor: isSelected ? '#EB7A58' : '#DCDDE5',
                  },
                }}
                type='button'
              >
                <Stack sx={{gap: 0.75}}>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: 700,
                      color: '#050A14',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'normal',
                      wordBreak: 'break-word',
                    }}
                  >
                    {getParticipantName(participantDetails, participantRn)}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: '12px',
                      fontWeight: 400,
                      color: isSelected ? '#D85D31' : '#63708A',
                    }}
                  >
                    {getParticipantType(participantRn)}
                  </Typography>
                </Stack>
              </ButtonBase>
            );
          })
        }
      </Stack>
    </Stack>
  );
};

ParticipantSelector.propTypes = {
  participantDetails: PropTypes.object.isRequired,
  participantRns: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedParticipantRn: PropTypes.string,
  setSelectedParticipantRn: PropTypes.func.isRequired,
};

export default React.memo(ParticipantSelector);
